import { post } from './client'
import type { BackendMeta } from './types'

export type AddCaseQuery = BackendMeta<
  '/api/workspaces/{workspace_id}/cases/{case_id}/queries',
  'post'
>

export type AddCaseQueryParams = {
  workspaceId: string
  caseId: string
  fileIds: string[]
  text: string
  agentId: string | null
  webSearch?: boolean
}

export const addCaseQuery = async ({
  caseId,
  fileIds,
  text,
  workspaceId,
  agentId,
  webSearch,
}: AddCaseQueryParams) =>
  post<AddCaseQuery['body'], AddCaseQuery['successResponse'], AddCaseQuery['path']>(
    `/api/workspaces/${workspaceId}/cases/${caseId}/queries`,
    {
      /**
       * We will receive 400 errors if we send both an agent and request a web
       * search. This is the most robust way to ensure we never send both.
       */
      agent_id: webSearch ? undefined : agentId,
      file_ids: fileIds,
      text,
      search_web: webSearch || false,
    },
  )
